import { ReactNode } from 'react';
import ApplePodcasts from '../icons/ApplePodcasts';
import Breaker from '../icons/Breaker';
import Deezer from '../icons/Deezer';
import GooglePodcasts from '../icons/GooglePodcasts';
import IHeartRadio from '../icons/IHeartRadio';
import Pocketcast from '../icons/Pocketcast';
import RadioPublic from '../icons/RadioPublic';
import Spotify from '../icons/Spotify';
import Stitcher from '../icons/Stitcher';
import TuneIn from '../icons/TuneIn';

export const iconMap: Record<string, ReactNode> = {
  spotify: <Spotify />,
  pocketcast: <Pocketcast />,
  'apple podcasts': <ApplePodcasts />,
  radiopublic: <RadioPublic />,
  stitcher: <Stitcher />,
  'tune in': <TuneIn />,
  'google podcasts': <GooglePodcasts />,
  breaker: <Breaker />,
  deezer: <Deezer />,
  iheartradio: <IHeartRadio />,
};
